/* eslint-disable import/prefer-default-export */
import { gql } from '@apollo/client';

export const acceptOptinGql = gql`
  mutation acceptOptin($inviteCode: String!, $optinCode: String!, $input: PublishablePostInput!) {
    acceptOptin (path: $path, inviteCode: $inviteCode, optinCode: $optinCode, input: $input) @rest(
      path: "invites/{args.inviteCode}/marketingOptin/{args.optinCode}",
      method: "POST"
    ) {
      NoResponse
    }
  }
`;
